import { mask } from "jquery-mask-plugin";

export default {
  init(selector) {
    $(selector).each((index, input) => {
      const el = $(input);
      const format = el.data("mask-format");
      const target = el.data("target");
      el.mask(format, {
        onKeyPress: () => {
          const val = $(input).cleanVal();
          $(`#${target}`).val(val);
        },
      });
    });
  },
};
